export const initHotspot = () => {
  const groups = document.querySelectorAll('.product-group');
  const slider = document.querySelector('.HeroSlider--Hotspot');
  let sliderArrows = null;
  let tooltipCounter = 0;
  setTimeout(() => {
    if (slider) {
      sliderArrows = slider.querySelector('.splide__arrows');
    }
  }, 100);

  if (!groups || groups.length === 0) return;

  const safeNumber = (value) => {
    if (value == null) return null;
    if (typeof value === "number") return Number.isFinite(value) ? value : null;
    // Supporta stringhe tipo "60", "60%", "25,5"
    if (typeof value === "string") {
      const normalized = value.trim().replace("%", "").replace(",", ".");
      const n = Number(normalized);
      return Number.isFinite(n) ? n : null;
    }
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  };

  const parseAltJson = (alt) => {
    if (!alt) return null;
    const raw = String(alt).trim();
    if (!raw.startsWith("{") || !raw.endsWith("}")) return null;
    try {
      return JSON.parse(raw);
    } catch (_e) {
      // Fallback "tollerante" per ALT che somigliano a JSON ma non sono validi
      // (es: virgolette non escapeate dentro description: ... "Foreste Urbane" ...)
      const pick = (re) => {
        const m = raw.match(re);
        return m && m[1] != null ? m[1] : null;
      };

      const leftRaw = pick(/"left"\s*:\s*([0-9]+(?:[.,][0-9]+)?%?)/);
      const topRaw = pick(/"top"\s*:\s*([0-9]+(?:[.,][0-9]+)?%?)/);
      if (leftRaw == null || topRaw == null) return null;

      const title =
        pick(/"title"\s*:\s*"([\s\S]*?)"\s*,\s*"description"\s*:/) ??
        pick(/"title"\s*:\s*"([\s\S]*?)"\s*(?:,|\})/);

      const tooltipPosition =
        pick(/"tooltipPosition"\s*:\s*"([\s\S]*?)"\s*(?:,|\})/) ??
        pick(/"tooltip"\s*:\s*"([\s\S]*?)"\s*(?:,|\})/);

      // Prendi tutto fino all'ultima " prima della }
      const description =
        pick(/"description"\s*:\s*"([\s\S]*)"\s*\}\s*$/);

      return {
        left: leftRaw,
        top: topRaw,
        ...(title != null ? { title } : {}),
        ...(tooltipPosition != null ? { tooltipPosition } : {}),
        ...(description != null ? { description } : {}),
      };
    }
  };

  const setActive = (hotspotEl, active) => {
    hotspotEl.classList.toggle("is-active", active);
    const trigger = hotspotEl.querySelector(".hotspot__dot");
    const tooltip = hotspotEl.querySelector(".hotspot__tooltip");
    const closeBtn = hotspotEl.querySelector(".hotspot__close");
    if (trigger) trigger.setAttribute("aria-expanded", active ? "true" : "false");
    if (tooltip) {
      tooltip.setAttribute("aria-hidden", active ? "false" : "true");
      if ('inert' in tooltip) {
        tooltip.inert = !active;
      }
    }
    if (closeBtn) {
      closeBtn.tabIndex = active ? 0 : -1;
    }
    if (!active && tooltip && trigger && tooltip.contains(document.activeElement)) {
      trigger.focus();
    }
    // Nascondi/mostra le frecce solo se <= 950px
    if (sliderArrows) {
      const anyActive = document.querySelector('.hotspot.is-active');
      const isMobile = window.matchMedia('(max-width: 950px)').matches;
      sliderArrows.style.display = (anyActive && isMobile) ? 'none' : '';
    }
  };

  groups.forEach((group) => {
    // Prendiamo solo le immagini che hanno un ALT con JSON (left/top/description...) ed escludiamo l'immagine di background.
    const candidateImgs = Array.from(group.querySelectorAll("img"));
    const hotspotImgs = candidateImgs.filter((img) => {
      if (!img || !(img instanceof HTMLImageElement)) return false;
      if (img.classList.contains("bg-product")) return false;
      if (img.closest(".bg-product")) return false;
      const data = parseAltJson(img.alt);
      return !!data && (data.left != null) && (data.top != null);
    });

    if (hotspotImgs.length === 0) return;

    const closeAllInGroup = (exceptEl = null) => {
      group.querySelectorAll(".hotspot.is-active").forEach((el) => {
        if (exceptEl && el === exceptEl) return;
        setActive(el, false);
      });
    };

    hotspotImgs.forEach((img) => {
      // Evita di reinizializzare se lo script gira più volte
      if (img.closest(".hotspot")) return;

      const data = parseAltJson(img.alt);
      if (!data) return;

      const left = safeNumber(data.left);
      const top = safeNumber(data.top);
      if (left == null || top == null) return;

      const title = (data.title ?? data.heading ?? data.label ?? "").toString().trim();
      const description = (data.description ?? data.text ?? "").toString().trim();
      const tooltipPosRaw = (data.tooltipPosition ?? data.tooltip ?? "").toString().trim().toLowerCase();

      // Crea il contenitore principale
      const hotspotEl = document.createElement("div");
      hotspotEl.className = "hotspot";

      // Crea il wrapper per contenuto (img + button)
      const contentWrapper = document.createElement("div");
      contentWrapper.className = "hotspot__content";
      contentWrapper.style.position = "absolute";
      contentWrapper.style.left = `${left}%`;
      contentWrapper.style.top = `${top}%`;

      // Varianti di posizionamento tooltip (per evitare overflow ai bordi)
      // 1) Se esplicito nel JSON, ha priorità su tutto
      //    Esempi: "tooltipPosition": "left" | "right" | "bottom"
      if (tooltipPosRaw) {
        if (tooltipPosRaw.includes("right")) hotspotEl.classList.add("hotspot--right");
        if (tooltipPosRaw.includes("bottom")) hotspotEl.classList.add("hotspot--bottom");
        if (tooltipPosRaw.includes("left")) hotspotEl.classList.add("hotspot--left");
        // "left" ora ha una classe dedicata
      } else {
        // 2) Altrimenti regole automatiche
        // Desktop rule: left < 50 => nuvoletta a sinistra (default), left >= 50 => a destra
        const isDesktop = window.matchMedia && window.matchMedia("(min-width: 1024px)").matches;
        if (isDesktop && left >= 50) hotspotEl.classList.add("hotspot--right");
        if (top < 25) hotspotEl.classList.add("hotspot--bottom");
      }

      // Trigger (riutilizziamo l'immagine esistente)
      // L'immagine serve solo da "contenitore dati" (ALT JSON) e viene nascosta in frontend.
      // Il trigger cliccabile è un <button> stilato via CSS (pseudo-elementi).
      const a11yLabel = title || description || "Hotspot";

      const dotBtn = document.createElement("button");
      dotBtn.type = "button";
      dotBtn.className = "hotspot__dot";
      dotBtn.setAttribute("aria-expanded", "false");
      dotBtn.setAttribute("aria-label", a11yLabel);
      dotBtn.setAttribute("aria-haspopup", "dialog");

      img.classList.add("hotspot__data");
      img.alt = "";
      img.setAttribute("aria-hidden", "true");
      img.setAttribute("tabindex", "-1");

      // Tooltip
      const tooltipEl = document.createElement("div");
      tooltipEl.className = "hotspot__tooltip";
      tooltipEl.setAttribute("aria-hidden", "true");
      tooltipEl.setAttribute("role", "dialog");
      tooltipEl.setAttribute("aria-modal", "false");
      tooltipEl.setAttribute("aria-label", title || a11yLabel);
      tooltipEl.style.position = "absolute";
      tooltipEl.style.left = `${left}%`;
      tooltipEl.style.top = `${top}%`;
      tooltipEl.id = `hotspot-tooltip-${tooltipCounter++}`;
      dotBtn.setAttribute("aria-controls", tooltipEl.id);
      if ('inert' in tooltipEl) {
        tooltipEl.inert = true;
      }

      if (title) {
        const h = document.createElement("div");
        h.className = "hotspot__title";
        h.textContent = title;
        tooltipEl.appendChild(h);
      }

      if (description) {
        const p = document.createElement("div");
        p.className = "hotspot__text";
        p.textContent = description;
        tooltipEl.appendChild(p);
      }

      // Bottone X per chiudere
      const closeBtn = document.createElement("button");
      closeBtn.type = "button";
      closeBtn.className = "hotspot__close";
      closeBtn.setAttribute("aria-label", "Chiudi hotspot");
      closeBtn.tabIndex = -1;
      closeBtn.innerHTML = "&times;";
      closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        setActive(hotspotEl, false);
      });
      closeBtn.addEventListener("keydown", (e) => {
        if (e.key !== "Escape") return;
        e.preventDefault();
        setActive(hotspotEl, false);
      });
      tooltipEl.appendChild(closeBtn);

      // Inserisci hotspot nella pagina
      const parent = img.parentNode;
      if (!parent) return;
      parent.insertBefore(hotspotEl, img);
      // Inserisci img e button nel wrapper
      contentWrapper.appendChild(img);
      contentWrapper.appendChild(dotBtn);
      // Inserisci wrapper e tooltip come fratelli dentro hotspot
      hotspotEl.appendChild(contentWrapper);
      hotspotEl.appendChild(tooltipEl);

      const toggle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isActive = hotspotEl.classList.contains("is-active");
        closeAllInGroup(hotspotEl);
        setActive(hotspotEl, !isActive);
      };

      dotBtn.addEventListener("click", toggle);
      dotBtn.addEventListener("focus", () => {
        closeAllInGroup(hotspotEl);
      });
      dotBtn.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") toggle(e);
        if (e.key === "Escape") {
          e.preventDefault();
          closeAllInGroup();
        }
      });
    });

    // Click fuori hotspot => chiudi
    group.addEventListener("click", (e) => {
      if (e.target && e.target.closest && e.target.closest(".hotspot")) return;
      closeAllInGroup();
    });

    group.addEventListener("focusin", (e) => {
      if (e.target && e.target.closest && e.target.closest(".hotspot")) return;
      closeAllInGroup();
    });

    // Esc globale => chiudi hotspot del gruppo
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      closeAllInGroup();
    });
  });
};
